import ListItemText from "@material-ui/core/ListItemText";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import withStyles from "@material-ui/core/styles/withStyles";
import classNames from "classnames";
import React from "react";
import get from "lodash/get";
import CheckImg from "../../Assets/Images/aaa.png";
import "./index.css";

const styles = (theme) => ({
  menuItem: {
    "&:focus": {
      backgroundColor: "#2ecaff29",
      "& $primary, & $icon": {
        color: theme.palette.common.white,
      },
    },
  },
  primary: {},
  nopadding: {
    padding: 0,
  },
  icon: {},
});
const SelectList = (props) => {
  const { classes } = props;

  return (
    <MenuList className="padding-top-0">
      {props.data &&
        get(props, "data", []).map((item) => (
          <MenuItem
            key={item.key}
            className="padding-left-0 select-list-menu-item"
            onClick={() => props.onSelected(item)}
          >
            <ListItemText
              className="padding-left-0 normal-dark-secondary margin-bottom-0"
              style={{ whiteSpace: "normal" }}
              primary={item.displayname}
            />
            {props.Selected == item.displayvalue ? (
              <img src={CheckImg} alt="icon" height="20" />
            ) : (
              <span className="not-selected"></span>
            )}
          </MenuItem>
        ))}
    </MenuList>
  );
};
// export default SelectList;
export default withStyles(styles)(SelectList);
